module.exports = __webpack_public_path__ + "img/bg4.87eaa86a.png";